enum CAR_PRICE_TYPE {
    MEDIAN = 1,
    LOWEST,
    HIGHEST,
}

export default CAR_PRICE_TYPE;
